import React from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import { Button } from "antd";
import "./UserHomepage.scss";

const Addresses: React.FC = () => {
    const addresses = [
        { homeName: "Home", address: "123, Maple Street, Vancouver BC" },
        { homeName: "Office", address: "456, Pine Avenue, Surrey BC" },
      ];
  return (
    <div style={{ padding: "20px" }}>
      
      <div className="profile-headers">Addresses</div>

      <Row gutter={[30, 30]} className="address-row">
      {addresses.map((item, index) => (
        <Col
        xs={24} // full width on mobile
        sm={12} // two per row on small+
        key={index}
      >
        <div className="address-card">
        <div className="address-card-header">
          <EnvironmentOutlined className="map-icon" />
          <span className="home-name">{item.homeName}</span>
        </div>
        <p className="address-text">{item.address}</p>
        <div className="address-buttons">
          <Button className="edit-btn">Edit</Button>
          <Button type="text" className="delete-btn">
            Delete
          </Button>
        </div>
      </div>
      </Col>
      ))}
    </Row>
      
      
    </div>
  );
};

export default Addresses;
